import React from 'react';
import { useTexts } from '../../../hooks/useTexts';
import './Footer.css';

export default function Footer() {
  const t = useTexts();

  return (
    <footer className="site-footer">
      <div className="footer-logo">COPAS<span>.</span>FILMS</div>

      <div className="footer-socials">
        <a href="https://youtube.com" target="_blank" rel="noreferrer">YouTube</a>
        <a href="https://instagram.com" target="_blank" rel="noreferrer">Instagram</a>
        <a href="https://linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a>
        <a href="https://tiktok.com" target="_blank" rel="noreferrer">TikTok</a>
      </div>

      <div className="footer-copy">{t.footer.rights}</div>
    </footer>
  );
}
